// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '../../../theme/index.css'
import App from './index.vue'
import router from '@/publicResource/router'
import {
  getStore,
  setStore
} from '@/publicResource/utils/utils.js'
import '../../../bower_components/tracking.js/build/tracking-min'
import '../../../bower_components/tracking.js/build/data/face-min'
// import '../../../bower_components/platform/platform'
import i18n from '@/publicResource/utils/i18n'
import store from '@/publicResource/utils/state'
Vue.use(ElementUI)

/* IE下提示Promise未定义的解决方法 */
if (!window.Promise) {
  window.Promise = Promise
}
Vue.config.productionTip = false
Vue.prototype.$tracking = tracking

// Vue.use(tracking)
// Object.defineProperty(Vue.prototype, '$tracking', {
//   value: tracking
// })
router.beforeEach((to, from, next) => {
  if (to.path) {
    _hmt.push(['_trackPageview', to.fullPath])
  }
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    let logininfo = JSON.parse(getStore('loginInfo'))
    let logininfouser = JSON.parse(getStore('loginInfouser'))
    if (logininfo || logininfouser) { // 判断当前的token是否存在
      // 工作人员只能访问当前菜单权限里的路由
      let returl = ''
      let hasAuth = false // 默认不可以访问
      let isback = false
      // 判断当前的路由是否是工作人员端

      for (let i = 0, l = to.matched.length; i < l; i++) {
        if (to.matched[i].meta.isback) {
          isback = true
          break
        }
      }
      let staffurl = getmenulist()
      if (isback && staffurl.length > 0) {
        returl = staffurl[0].child[0].menuUrl
        for (let i = 0, l = staffurl.length; i < l; i++) {
          for (let j = 0, jl = staffurl[i].child.length; j < jl; j++) {
            if (~to.fullPath.indexOf(staffurl[i].child[j].menuUrl)) {
              hasAuth = true
            }
          }
        }
      }
      // 个人中心的路由需要特殊处理
      let infocenterurl = ['/infocenter/serviceinfo', '/infocenter/orginfo', '/infocenter/setaccount', '/infocenter/setpwd']
      if (~infocenterurl.indexOf(to.fullPath) && logininfo) {
        isback = true
        hasAuth = true
      }
      if (isback) {
        if (hasAuth) {
          next()
        } else {
          if (logininfo) {
            next({
              path: returl
            })
          } else {
            next({
              path: '/useraction/404'
            })
          }
        }
      } else {
        if (logininfouser) {
          next()
        } else {
          next({
            path: '/useraction/login'
          })
        }
      }
      // next();
    } else {
      if (to.fullPath.indexOf('/userCenter') >= 0 || to.fullPath.indexOf('/peoMediation') >= 0 || to.fullPath.indexOf('/adminMediation') >= 0 || to.fullPath.indexOf('/onlineMediation') >= 0 || to.fullPath.indexOf('/consultation') >= 0) {
        next({
          path: '/useraction/login',
          query: {
            redirect: to.fullPath
          } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      } else {
        setStore('loginCurrTab', 1)
        next({
          path: '/useraction/login',
          query: {
            redirect: to.fullPath
          } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    }
  } else {
    next()
  }
})
// 获取工作人员菜单权限
function getmenulist () {
  var loginInfo = JSON.parse(getStore('loginInfo'))
  let menulist = []
  if (loginInfo) {
    for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
      let obj = {
        parent: '',
        child: []
      }
      if (loginInfo.userMenuInfo[i].parentId === 0) {
        obj.parent = loginInfo.userMenuInfo[i]
        menulist.push(obj)
      }
    }
    for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
      for (let j = 0, jl = menulist.length; j < jl; j++) {
        if (loginInfo.userMenuInfo[i].parentId === menulist[j].parent.id) {
          menulist[j].child.push(loginInfo.userMenuInfo[i])
        }
      }
    }
  }
  return menulist
}

window.vm = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/module/index/index.js